// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"da51a739f7--checkbox--l9NIC","label":"da51a739f7--label--wg3E4","box":"da51a739f7--box--LEKeq","hasLabel":"da51a739f7--hasLabel--uSvdq"};